<template>
  <div class="employee-export">
    <button
      type="button"
      class="employee-export__button"
      @click="openModal"
    >
      Export CSV
    </button>

    <div
      v-if="isOpen"
      class="employee-export__overlay"
      @click.self="closeModal"
    >
      <section class="employee-export__modal">
        <header class="employee-export__header">
          <div>
            <h3>Export activité salariés</h3>
            <p>Données exportées selon la période et les domaines sélectionnés.</p>
          </div>
          <button type="button" class="employee-export__close" @click="closeModal">×</button>
        </header>

        <div class="employee-export__body">
          <section class="employee-export__group">
            <header>
              <h4>Données ALL</h4>
              <button type="button" @click="toggleAllFields">
                {{ areAllFieldsSelected ? 'Tout désélectionner' : 'Tout sélectionner' }}
              </button>
            </header>
            <label
              v-for="field in allFieldOptions"
              :key="field.value"
              class="employee-export__option"
            >
              <input type="checkbox" :value="field.value" v-model="selectedAllFields">
              <span>{{ field.label }}</span>
            </label>
          </section>

          <section class="employee-export__group">
            <header>
              <h4>Données client par client</h4>
              <button type="button" @click="toggleClientFields">
                {{ areClientFieldsSelected ? 'Tout désélectionner' : 'Tout sélectionner' }}
              </button>
            </header>
            <label
              v-for="field in clientFieldOptions"
              :key="field.value"
              class="employee-export__option"
            >
              <input type="checkbox" :value="field.value" v-model="selectedClientFields">
              <span>{{ field.label }}</span>
            </label>
          </section>
        </div>

        <footer class="employee-export__footer">
          <button type="button" class="employee-export__secondary" @click="closeModal">
            Annuler
          </button>
          <button
            type="button"
            class="employee-export__primary"
            :disabled="isExportDisabled"
            @click="exportCsv"
          >
            {{ isExporting ? 'Export en cours...' : 'Exporter' }}
          </button>
        </footer>
      </section>
    </div>
  </div>
</template>

<script>
import { http } from '@/services/api.service'

const ALL_FIELDS = [
  { value: 'download_rate_average', label: '% DL en moyenne' },
  { value: 'download_rate_workforce', label: '% DL sur l’effectif' },
  { value: 'downloads_period', label: 'Valeur DL sur la période' },
  { value: 'downloads_cumulative', label: 'Valeur DL cumulée' },
  { value: 'active_users_rate_average', label: '% UA en moyenne sur la période' },
  { value: 'active_users_rate_downloads', label: '% UA sur les DL sur la période' },
  { value: 'active_users', label: 'Valeur UA sur la période' },
  { value: 'active_logins', label: 'Nombre de connexions total sur la période' },
  { value: 'reads_total', label: 'Nombre de lecture all sur la période' },
  { value: 'reads_article', label: 'Nombre de lecture article sur la période' },
  { value: 'reads_faq', label: 'Nombre de lecture FAQ sur la période' },
  { value: 'reads_per_download', label: 'Nombre d’article lu par salariés lu sur la période' },
  { value: 'reads_per_download_average', label: 'Nombre d’article lu par salariés lu sur la période en moyenne chez all' },
  { value: 'published_contents', label: 'Nombre de contenus publiés sur la période' },
  { value: 'published_articles', label: 'Nombre d’articles publiés sur la période' },
  { value: 'published_faqs', label: 'Nombre de FAQ publiées sur la période' },
  { value: 'published_surveys', label: 'Nombre de sondages publiés sur la période' },
  { value: 'searches_total', label: 'Nombre de recherche' },
  { value: 'top_keywords', label: 'Liste des mots clés les + recherchés' },
  { value: 'sensitive_terms', label: 'Liste des mots sensibles' }
]

const CLIENT_FIELDS = [
  { value: 'download_rate', label: '% DL' },
  { value: 'downloads_period', label: 'Valeur DL sur la période' },
  { value: 'downloads_cumulative', label: 'Valeur DL cumulée' },
  { value: 'active_users_rate', label: '% UA sur la période' },
  { value: 'active_users', label: 'Valeur UA sur la période' },
  { value: 'active_logins', label: 'Nombre de connexions total sur la période' },
  { value: 'reads_total', label: 'Nombre de lecture all sur la période' },
  { value: 'reads_article', label: 'Nombre de lecture article sur la période' },
  { value: 'reads_faq', label: 'Nombre de lecture FAQ sur la période' },
  { value: 'reads_per_download', label: 'Nombre d’article lu par salariés sur la période' },
  { value: 'published_contents', label: 'Nombre de contenus publiés sur la période' },
  { value: 'published_articles', label: 'Nombre d’articles publiés sur la période' },
  { value: 'published_faqs', label: 'Nombre de FAQ publiées sur la période' },
  { value: 'published_surveys', label: 'Nombre de sondages publiés sur la période' },
  { value: 'searches_total', label: 'Nombre de recherche' },
  { value: 'top_keywords', label: 'Liste des mots clés les + recherchés' },
  { value: 'sensitive_terms', label: 'Liste des mots sensibles' }
]

export default {
  name: 'EmployeeActivityExportButton',
  props: {
    dateRange: {
      type: [Array, String],
      default: () => []
    },
    selectedDomainUuids: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isOpen: false,
      isExporting: false,
      allFieldOptions: ALL_FIELDS,
      clientFieldOptions: CLIENT_FIELDS,
      selectedAllFields: ALL_FIELDS.map(field => field.value),
      selectedClientFields: CLIENT_FIELDS.map(field => field.value)
    }
  },
  computed: {
    areAllFieldsSelected () {
      return this.selectedAllFields.length === this.allFieldOptions.length
    },
    areClientFieldsSelected () {
      return this.selectedClientFields.length === this.clientFieldOptions.length
    },
    isExportDisabled () {
      return this.isExporting || (this.selectedAllFields.length === 0 && this.selectedClientFields.length === 0)
    }
  },
  methods: {
    openModal () {
      this.isOpen = true
    },
    closeModal () {
      if (!this.isExporting) {
        this.isOpen = false
      }
    },
    toggleAllFields () {
      this.selectedAllFields = this.areAllFieldsSelected ? [] : this.allFieldOptions.map(field => field.value)
    },
    toggleClientFields () {
      this.selectedClientFields = this.areClientFieldsSelected ? [] : this.clientFieldOptions.map(field => field.value)
    },
    buildParams () {
      const params = {
        allFields: this.selectedAllFields,
        clientFields: this.selectedClientFields
      }

      if (Array.isArray(this.dateRange) && this.dateRange.length === 2) {
        params.dateStart = this.dateRange[0]
        params.dateEnd = this.dateRange[1]
      }

      if (Array.isArray(this.selectedDomainUuids) && this.selectedDomainUuids.length > 0) {
        params.domains = this.selectedDomainUuids
      }

      return params
    },
    exportCsv () {
      if (this.isExportDisabled) {
        return
      }

      this.isExporting = true
      http.get('/dashboard/employee-activity-export', {
        params: this.buildParams(),
        responseType: 'blob'
      })
        .then(response => {
          const filename = this.extractFilename(response.headers?.['content-disposition'])
          this.downloadBlob(response.data, filename)
          this.isOpen = false
        })
        .catch(() => {
          this.$buefy.toast.open({
            message: 'Impossible de générer l’export CSV.',
            type: 'is-danger'
          })
        })
        .finally(() => {
          this.isExporting = false
        })
    },
    extractFilename (contentDisposition) {
      const fallback = 'export-activite-salaries.csv'
      if (!contentDisposition) {
        return fallback
      }

      const match = contentDisposition.match(/filename="?([^"]+)"?/)
      return match?.[1] || fallback
    },
    downloadBlob (blob, filename) {
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    }
  }
}
</script>

<style scoped>
.employee-export {
  flex: 0 0 auto;
}

.employee-export__button,
.employee-export__primary,
.employee-export__secondary {
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1;
  padding: 0.75rem 1rem;
}

.employee-export__button,
.employee-export__primary {
  background: #2563eb;
  color: #ffffff;
}

.employee-export__button:hover,
.employee-export__primary:hover {
  background: #1d4ed8;
}

.employee-export__primary:disabled {
  cursor: not-allowed;
  background: #9ca3af;
}

.employee-export__secondary {
  border: 1px solid #d1d5db;
  background: #ffffff;
  color: #111827;
}

.employee-export__overlay {
  position: fixed;
  inset: 0;
  z-index: 10030;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: rgba(15, 23, 42, 0.45);
}

.employee-export__modal {
  width: min(980px, 100%);
  max-height: min(760px, calc(100vh - 3rem));
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  border-radius: 1rem;
  background: #ffffff;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.22);
}

.employee-export__header,
.employee-export__footer {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.25rem;
}

.employee-export__header {
  border-bottom: 1px solid #e5e7eb;
}

.employee-export__footer {
  justify-content: flex-end;
  border-top: 1px solid #e5e7eb;
}

.employee-export__header h3 {
  margin: 0;
  color: #111827;
  font-size: 1.125rem;
  font-weight: 600;
}

.employee-export__header p {
  margin: 0.25rem 0 0;
  color: #4b5563;
  font-size: 0.875rem;
}

.employee-export__close {
  width: 2rem;
  height: 2rem;
  border: 1px solid #d1d5db;
  border-radius: 9999px;
  background: #ffffff;
  color: #4b5563;
  font-size: 1.25rem;
  line-height: 1;
}

.employee-export__body {
  flex: 1 1 auto;
  min-height: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: start;
  gap: 1rem;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  padding: 1.25rem;
}

.employee-export__group {
  min-width: 0;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  overflow: hidden;
}

.employee-export__group header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  border-bottom: 1px solid #e5e7eb;
  background: #f9fafb;
  padding: 0.85rem 1rem;
}

.employee-export__group h4 {
  margin: 0;
  color: #111827;
  font-size: 0.875rem;
  font-weight: 600;
}

.employee-export__group header button {
  color: #2563eb;
  font-size: 0.75rem;
  font-weight: 600;
}

.employee-export__option {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  padding: 0.7rem 1rem;
  border-bottom: 1px solid #e5e7eb;
  color: #111827;
  font-size: 0.875rem;
}

.employee-export__option:last-child {
  border-bottom: 0;
}

.employee-export__option input {
  margin-top: 0.2rem;
}

@media (max-width: 860px) {
  .employee-export__body {
    grid-template-columns: 1fr;
  }
}
</style>
